<template>
  <div>
    <FiltroMandatos v-model="filtro" @filtrar="(obj) => changeFiltro(obj)" @reload="reloadFiltro" />
    <div class="pa-2" v-if="!loading">
      <table-cadu
        :class="$vuetify.breakpoint.xs ? 'mandatos-mobile' : 'mandatos'"
        v-model="selected"
        custom
        nameTab="mandatos"
        :editar="opcaoEditar"
        :rows="rows"
        :showCheck="opcaoEditar === true && canEdit"
        :rowsHeader="rowsHeader"
        :items="['05', '10', '15']"
        :elementsPerPageProp="elementsPerPage"
        :pagina="pagina"
        :qtPaginas="qtPaginas"
        :qtResultados="qtResultados"
        :texto="canAdd ? '+ adicionar mandato' : ''"
        :ordemProp="ordem"
        :disabledButtons="[true, canEdit, canEdit, false, false]"
        :showAnexo="true"
        @filtro-click="filtro = true"
        @change-element="changeSelect"
        @change-page="(page) => changePage(page.currentPage)"
        @clickButton="clickMandatos"
        @ordena="(obj) => changeOrdem(obj)"
        @anexar="emitSend"
      />
    </div>
    <ExcluirModal
      :text="'Tem certeza que deseja excluir esse Mandato?'"
      :showDelete="showDelete"
      @close="closeDelete"
      @confirmDelete="confirm()"
    />
    <SucessoModal :showSucess="showSucess" :sucessType="type" successName="Mandato" @close="showSucess = false" />
    <error-modal v-model="error" :errObj="errObj" />
    <component-loading style="height: 180px;" :value="loading" />
  </div>
</template>

<script>
import FiltroMandatos from './FiltroMandatos'
import Mandatos from '@/services/Mandatos/Mandatos'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    FiltroMandatos
  },
  props: {
    canEdit: {
      type: Boolean,
      required: false
    },
    canAdd: {
      type: Boolean,
      required: false
    },
    canDel: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      rows: [],
      rowsHeader: [
        { text: 'Tipo de Mandato', icon: 'repeat' },
        { text: 'Data Início', icon: 'repeat' },
        { text: 'Data Fim', icon: 'repeat' },
        { text: 'Status' }
      ],
      pagina: 1,
      qtPaginas: 0,
      qtResultados: 0,
      selected: [],
      filtro: false,
      tokenBearer: '',
      loading: false,
      vigente: 'VIGENTE',
      elementsPerPage: '10',
      ordem: 'asc',
      ordenacao: 'tipoMandato.nome',
      hoverIndex: -1,
      tipoMandatoId: '',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      showDelete: false,
      showSucess: false,
      type: '',
      delSelected: [],
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },
  async beforeMount() {
    this.loading = true
    this.tokenBearer = localStorage.getItem('tokenBearer')
    await this.loadMandatos()
    this.loading = false

    EventBus.$on('atualizarTabela', () => {
      this.loading = true
      this.loadMandatos()
      this.loading = false
    })
  },
  methods: {
    closeDelete() {
      this.showDelete = false
      this.delSelected = []
    },
    emitSend() {
      EventBus.$emit('showAnexo', 'Mandatos')
    },
    async reloadFiltro() {
      this.loading = true
      this.filtro = false
      this.vigente = 'VIGENTE'
      this.tipoMandatoId = ''
      await this.loadMandatos()
      this.loading = false
    },
    clickMandatos(obj) {
      let type = obj.type

      switch (type) {
        case 'add':
          this.$emit('add')
          break
        case 'view':
          this.$emit('view', this.rows[obj.index])
          break
        case 'edit':
          this.$emit('edit', this.rows[obj.index])
          break
        case 'delete':
          this.type = 'del'
          this.delSelected.push(this.rows[obj.index].id)
          this.showDelete = true
          break
        case 'delAll':
          this.type = 'del'
          this.delSelected = obj.selected
          this.showDelete = true
          break
        default:
          break
      }
    },
    async confirm() {
      this.showDelete = false
      this.loading = true
      await this.delMandatos(this.delSelected)
      this.loading = false
      this.delSelected = []
    },
    async changeFiltro(obj) {
      this.filtro = false
      this.loading = true
      this.vigente = obj.tipoVingencia === undefined ? 'VIGENTE' : obj.tipoVingencia
      this.tipoMandatoId = obj.idMandato
      await this.loadMandatos()
      this.loading = false
    },
    async changeSelect(element) {
      this.loading = true
      this.elementsPerPage = element
      this.pagina = 1
      await this.loadMandatos()
      this.loading = false
    },
    async changePage(pagina) {
      this.loading = true
      this.pagina = pagina
      await this.loadMandatos()
      this.loading = false
    },
    async changeOrdem({ ordem, index }) {
      const ordenacoes = {
        0: 'tipoMandato.nome',
        1: 'dataInicioVigencia',
        2: 'dataFimVigencia',
      }

      switch (index) {
        case 0:
        case 1:
        case 2:
          this.ordem = ordem
          this.ordenacao = ordenacoes[index]
          break

        default:
          this.ordenacao = 'tipoMandato.nome'
          this.ordem = 'asc'
          break
      }

      this.loading = true
      await this.loadMandatos()
      this.loading = false
    },
    async delMandatos(idArray) {
      let mandatos = new Mandatos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseDelete = await mandatos.delMandatos(idArray)
        this.$emit('changeMandato', responseDelete.data)
        await this.loadMandatos()
        this.showSucess = true
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async loadMandatos() {
      let mandatos = new Mandatos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseMandatos = await mandatos.getMandatos(this.args)
        responseMandatos = responseMandatos.data

        this.rows = responseMandatos.conteudo
        this.pagina = responseMandatos.pagina
        this.qtPaginas = responseMandatos.qtPaginas
        this.qtResultados = responseMandatos.qtResultados
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    hoverRow(index) {
      this.showButton = true
      this.hoverIndex = index
    },
    downRow() {
      this.hoverIndex = -100
      this.showButton = false
    }
  },
  computed: {
    args() {
      return `vigente=${this.vigente}&pagina=${this.pagina}&tamanhoPagina=${this.elementsPerPage}&ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}&tipoMandatoId=${this.tipoMandatoId}`
    }
  }
}
</script>

<style lang="sass">
.circle-status
    border-radius: 10px
    width: 9px
    height: 9px

.mandatos-mobile > .table-cadu
  padding: 20px 10px !important
  border: none
  border-radius: 0px
  width: 100% !important

.mandatos > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu > .table > table
    width: 100% !important

.mandatos-mobile > .table-cadu > .table > table
    width: 100% !important
</style>
